/* eslint-disable */

import { useRef, useEffect, useMemo } from 'react'
import { getCellDimensions } from '../utils/cellDimensions'

const getColorAt = (parsedData, i, j) => {
  const cell = parsedData[`${i}_${j}`];
  return cell?.backgroundColor || '#e0e0e0';
}

export default function ColorChart({
  color_chart
}) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  
  // Parse JSON once, not per cell
  const parsedData = useMemo(() => {
    try {
      return JSON.parse(color_chart.data);
    } catch {
      return {};
    }
  }, [color_chart.data]);

  // Get cell dimensions based on craft and stitch type
  const cellDimensions = useMemo(() => {
    const craft = color_chart.craft as 'knitting' | 'crochet' | 'cross_stitch' | null | undefined
    const crochetStitchType = color_chart.crochet_stitch_type as 'sc' | 'hdc' | 'dc' | null | undefined
    return getCellDimensions(craft || null, crochetStitchType || null)
  }, [color_chart.craft, color_chart.crochet_stitch_type])

  const cellWidth = cellDimensions.width;
  const cellHeight = cellDimensions.height;
  const cellMargin = cellDimensions.margin;
  const totalCellWidth = cellWidth + cellMargin * 2;
  const totalCellHeight = cellHeight + cellMargin * 2;
  const canvasWidth = color_chart.width * totalCellWidth;
  const canvasHeight = color_chart.height * totalCellHeight;

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Set canvas size with high DPI support
    const dpr = window.devicePixelRatio || 1;
    canvas.width = canvasWidth * dpr;
    canvas.height = canvasHeight * dpr;
    ctx.scale(dpr, dpr);

    // Draw all cells
    for (let i = 0; i < color_chart.height; i++) {
      for (let j = 0; j < color_chart.width; j++) {
        // Flip columns for display
        const colIndex = color_chart.width - 1 - j;
        const x = colIndex * totalCellWidth + cellMargin;
        const y = i * totalCellHeight + cellMargin;

        // Get cell color
        const color = getColorAt(parsedData, i, colIndex);

        // Draw cell background
        ctx.fillStyle = color;
        ctx.fillRect(x, y, cellWidth, cellHeight);
      }
    }
  }, [color_chart.width, color_chart.height, parsedData, canvasWidth, canvasHeight, totalCellWidth, totalCellHeight, cellWidth, cellHeight, cellMargin]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        display: 'block',
        width: `${canvasWidth}px`,
        height: `${canvasHeight}px`
      }}
    />
  );
}
